import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { Loading } from 'react-admin'
import styled from 'styled-components'

import { fetchHomeFeed } from 'api/core'

interface UserHomeFeedProps {
  user: any
}

const StyledLoading = styled(Loading)`
  height: auto;
  margin-top: 50px;
`

const MainTitle = styled(TableCell)`
  font-weight: 600;
  font-size: 20px;
`

const StyledTable = styled(Table)`
  width: 1000px;
`

const StyledRow = styled(TableRow)`
  width: 50px;
`

const SectionNameTableCell = styled(TableCell)`
  font-weight: 600;
  width: 7%;
`

const ContentTableCell = styled(TableCell)`
  width: 10%;
  border: 1px solid #e0e0e0;
`

const ContentSubSectionTableCell = styled(TableCell)`
  width: 20%;
  border: 1px solid #e0e0e0;
`

export function UserHomeFeed({ user }: UserHomeFeedProps) {
  const [loading, setLoading] = useState(true)
  const [homeFeed, setHomeFeed] = useState<any>([])

  useEffect(() => {
    fetchHomeFeed(user.id).then((data: any) => {
      setHomeFeed(data)
      setLoading(false)
    })
  }, [user.id])

  if (loading) {
    return <StyledLoading />
  }

  return (
    <TableContainer>
      <StyledTable>
        <TableHead>
          <StyledRow>
            <MainTitle>Home Feed</MainTitle>
          </StyledRow>
        </TableHead>
        <TableBody>
          {homeFeed.map((section: any) => (
            <StyledRow key={String(section.name)}>
              <SectionNameTableCell>{section.name}</SectionNameTableCell>
              <ContentTableCell>{section.main_text}</ContentTableCell>
              <ContentTableCell>{section.secondary_text}</ContentTableCell>
              <ContentTableCell>
                {section.sub_sections?.map((sub_section: any) => (
                  <>
                    <ContentSubSectionTableCell>{sub_section.main_text}</ContentSubSectionTableCell>
                    <ContentSubSectionTableCell>{sub_section.link}</ContentSubSectionTableCell>
                  </>
                ))}
              </ContentTableCell>
            </StyledRow>
          ))}
        </TableBody>
      </StyledTable>
    </TableContainer>
  )
}
